// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".promotion-msg .promo-text[data-v-b4fc8e14]{margin-left:-15px}", "",{"version":3,"sources":["webpack://./resources/js/components/product/header-pricing.vue"],"names":[],"mappings":"AAEA,4CACE,iBAAA","sourcesContent":["\n.promotion-msg{\n.promo-text{\n  margin-left: -15px;\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
